<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="银行存取款单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      show-checkbox
      @check-change="checkChange"
      v-if="trendShow"
      @row-select="rowSelect"
      :queryParamsAppend="{}"
      urlHash="finance/cashier/bankaccess"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-table
      v-show="tableData.length !== 0"
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      style="margin-top: 18px"
    >
      <el-table-column
        prop="OutAccountName"
        label="转出账户"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="OutAmount"
        label="转出金额"
        min-width="100"
        align="center"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">{{
          row.OutAmount.toLocaleString()
        }}</template>
      </el-table-column>
      <el-table-column
        prop="InAccountName"
        label="转入账户"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="InAmount"
        label="转入金额"
        min-width="100"
        align="center"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">{{
          row.InAmount.toLocaleString()
        }}</template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="备注"
        min-width="100"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/bankDoc").default,
      trendShow: true,
      tableData: [],
      list: [],
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/cashier/bankaccess");
    },
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/cashier/bankaccess")) {
      const findIndex = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "OutAmount"
      );
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
    }
  },
  methods: {
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(params).then((res) => {
        loading.close();
      });
    },
    checkChange(list) {
      this.list = list;
    },
    rowSelect({ DocId }) {
      this.api.info(DocId).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data.Dts;
        }
      });
    },
    del() {
      if (this.list.length === 0) {
        this.$message({ type: "warning", message: "请选择记录" });
        return;
      }
      console.log("this.list", this.list);
      let ids = this.list.map((item) => {
        return item.DocId;
      });
      this.$confirm("是否删除数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Ids: ids }).then((res) => {
            if (res.Code === 0) {
              this.$message({ type: "success", message: res.Msg });
              this.$emit("deleted");
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
